import DesktopNavBar from "./DesktopNavBar"
import MobileNavBar from "./MobileNavbar"
import { useSelector } from "react-redux"
import { ReduxState } from "@/redux/type"
import {
    Gift,
    UserCog,
    Award,
    User,
    Banknote,
} from 'lucide-react';

export interface NavItem {
    name: string;
    href: string;
    icon: React.ElementType;
    mode?: "dev";
    roles?: string[];
}

// Define all possible navigation items with role restrictions
const allNavItems: NavItem[] = [
    { name: 'Profile', href: '/profile', icon: User, roles: ['external_sales'] },
    // { name: 'Overview', href: '/overview', icon: Home, roles: ['external_sales'] },
    { name: 'Rewards', href: '/rewards', icon: Gift, roles: ['external_sales'] },
    { name: 'Payouts', href: '/payouts', icon: Banknote, roles: ['admin', 'external_sales'] },
    // { name: 'Customers', href: '/customers', icon: Users, roles: ['admin'] },
    // { name: 'Invoices', href: '/invoices', icon: List, roles: ['external_sales'] },
    { name: 'Rewards Claims', href: '/rewards-claims', icon: Award, roles: ['admin'] },
    // { name: 'Settings', href: '/settings', icon: Settings, roles: ['admin'] },
    { name: 'Users', href: '/users', icon: UserCog, roles: ['admin'] },
];

export default function Navbar() {
    const { role } = useSelector((state: ReduxState) => state.program);

    // Filter navigation items based on user role
    const navItems = allNavItems.filter(item => {
        // If no roles specified, show to everyone
        if (!item.roles) return true;
        // If roles specified, check if user has one of the required roles
        return item.roles.includes(role || '');
    });

    return (
        <>
            <DesktopNavBar navItems={navItems} />
            <MobileNavBar navItems={navItems} />
        </>
    )
}
